import store from '@/store';

const storeFiles = require.context('@/stores/', true, /\.(js|ts)$/);
storeFiles.keys().forEach(key => {
	let filePath: Array<string> = key.match(/[^\/]+/g) as Array<string>;
	const fileName: string = String(filePath.slice(-1)).replace(/\.[^.]+$/, '');

	filePath.shift(); //去掉第一位的根目录路径;
	filePath.pop(); //去掉最后一位带后缀的文件名;
	if (filePath.length > 0) {
		//子目录
		for (let i = 0; i < filePath.length; i++) {
			//支持嵌套模块;
			const storePath: string = filePath.slice(0, i + 1).toString();
			if (!(store.state as any).storePath) {
				//如果当前嵌套模块的中间路径模块不存在, 则新创建一个空模块;
				store.registerModule(filePath.slice(0, i + 1), { state: {} });
			}
		}
		filePath = [ ...filePath, fileName ]; //增加无后缀文件名到末尾用于最后注册store模块;
	} else {
		//根目录
		filePath = [ fileName ];
	}
	store.registerModule(filePath, { ...storeFiles(key).default, namespaced: true });
});

export default store;
